import { Item } from '../../services/list'

// Render a list as plain text for pasting into a chat or notes app.
//
// Deliberately not markdown: the usual destination is WhatsApp, which doesn't
// render it, so `- [ ] Milk` would reach the reader as noise — and that reader
// is typically someone who has never seen the app (see CLAUDE.md "Product
// principle"). Bullets and checks read the same everywhere. Sections become
// uppercase headings, mirroring how they look in the app.
export const listToText = (title: string, items: Item[]): string => {
    const lines: string[] = [title, '']

    items.forEach((item, i) => {
        if (item.kind === 'heading') {
            if (i > 0) lines.push('') // breathing room above each section
            lines.push(item.name.toUpperCase())
            return
        }
        lines.push((item.checked ? '✓ ' : '• ') + item.name)
    })

    return lines.join('\n').trim()
}
